var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { on: { click: _vm.trackExternalLinkClick } }, [
    _c(
      "a",
      {
        staticClass: "eh-link",
        attrs: { href: _vm.hrefUrl, target: _vm.target }
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm.showExternalIcon
          ? _c(
              "div",
              { staticClass: "d-inline" },
              [
                _c("font-awesome-icon", {
                  staticClass: "ml-1",
                  attrs: { icon: "external-link-alt", size: "sm" }
                })
              ],
              1
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-933af7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-933af7d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalLink.vue
// module id = null
// module chunks = 